import { HelpCircle } from "lucide-react";
import type { ProposalLanguage } from "./i18n";

export function ProposalOpenQuestionsSection({
  questions,
  language,
}: {
  questions: string[];
  language: ProposalLanguage;
}) {
  if (!questions.length) return null;

  const heading =
    language === "lt" ? "Klausimai sekančiam pokalbiui" : "Questions for our next conversation";

  return (
    <section
      id="open-questions"
      className="mx-auto max-w-5xl px-5 pb-12 pt-12 sm:px-10 sm:pb-20 sm:pt-20"
    >
      <h2 className="font-display text-[28px] font-extrabold leading-[1.05] tracking-display sm:text-5xl sm:leading-[1.02]">
        {heading.split(" ").slice(0, -2).join(" ")}{" "}
        <span className="brand-gradient-text">{heading.split(" ").slice(-2).join(" ")}</span>
      </h2>

      <ul className="mt-8 space-y-3">
        {questions.map((q, i) => (
          <li
            key={i}
            className="flex items-start gap-3 rounded-xl border border-border bg-white px-5 py-4 shadow-sm"
          >
            <HelpCircle className="mt-0.5 h-5 w-5 shrink-0 text-brand-blue" />
            <span className="text-sm leading-relaxed text-foreground sm:text-base">{q}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
